(function() {
  "use strict";

  function attachScrollableTabsWithFade(tabs) {
    if (!tabs) return;
    if (tabs.dataset.scrollEnhanceReady === "true") return;
    tabs.dataset.scrollEnhanceReady = "true";

    tabs.setAttribute("tabindex", "0");

    function syncTabsFade() {
      var maxScroll = tabs.scrollWidth - tabs.clientWidth;
      if (maxScroll <= 2) {
        tabs.classList.remove("has-left-fade");
        tabs.classList.remove("has-right-fade");
        return;
      }

      tabs.classList.toggle("has-left-fade", tabs.scrollLeft > 2);
      tabs.classList.toggle("has-right-fade", tabs.scrollLeft < (maxScroll - 2));
    }

    tabs.addEventListener("scroll", syncTabsFade, { passive: true });
    window.addEventListener("resize", syncTabsFade);

    tabs.addEventListener("wheel", function(event) {
      if (tabs.scrollWidth <= tabs.clientWidth) return;
      var xDelta = Math.abs(event.deltaX) > 0 ? event.deltaX : event.deltaY;
      if (!xDelta) return;
      event.preventDefault();
      tabs.scrollBy({ left: xDelta, behavior: "auto" });
    }, { passive: false });

    tabs.addEventListener("keydown", function(event) {
      if (tabs.scrollWidth <= tabs.clientWidth) return;
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      var step = Math.max(120, Math.round(tabs.clientWidth * 0.35));
      var dir = event.key === "ArrowRight" ? 1 : -1;
      tabs.scrollBy({ left: dir * step, behavior: "smooth" });
    });

    var isDragging = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;

    tabs.addEventListener("mousedown", function(event) {
      if (tabs.scrollWidth <= tabs.clientWidth) return;
      if (event.button !== 0) return;
      isDragging = true;
      dragStartX = event.pageX;
      dragStartScrollLeft = tabs.scrollLeft;
      tabs.classList.add("is-dragging");
      event.preventDefault();
    });

    window.addEventListener("mousemove", function(event) {
      if (!isDragging) return;
      var deltaX = event.pageX - dragStartX;
      tabs.scrollLeft = dragStartScrollLeft - deltaX;
    });

    window.addEventListener("mouseup", function() {
      if (!isDragging) return;
      isDragging = false;
      tabs.classList.remove("is-dragging");
    });

    syncTabsFade();
  }

  window.PrinceExplorers = window.PrinceExplorers || {};
  window.PrinceExplorers.attachScrollableTabsWithFade = attachScrollableTabsWithFade;
})();
